import React from 'react';
import PropTypes from 'prop-types';
import {EmailLink} from './LinkifiedText.style';

const EMAIL_REGEX = /[\w.+-]+@[\w-]+\.[\w.-]+/g;

// Plain copy (FAQ answers in constants.js/search.constants.js, etc.)
// sometimes includes a contact email as part of the sentence — this turns
// any email address found in `text` into a clickable mailto link, leaving
// everything else untouched.
const LinkifiedText = ({text}) => {
  if (!text) {
    return null;
  }
  const emails = text.match(EMAIL_REGEX) || [];
  if (emails.length === 0) {
    return text;
  }
  const parts = text.split(EMAIL_REGEX);
  return parts.reduce((nodes, part, index) => {
    nodes.push(part);
    const email = emails[index];
    if (email) {
      nodes.push(
        <EmailLink key={`${email}-${index}`} href={`mailto:${email}`}>
          {email}
        </EmailLink>
      );
    }
    return nodes;
  }, []);
};

LinkifiedText.propTypes = {
  text: PropTypes.string,
};

export default LinkifiedText;
